// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';

// Import style for web component
import styles from './web-component-style.scss';

/**
 * NewTag Web Component (<uo-new-tag>)
 * Displays a styled "New" label.
 */
@customElement( 'uo-new-tag' )
class NewTag extends LitElement {
	/**
	 * Define styles for the component.
	 * The styles are imported from an external SCSS file.
	 */
	static styles = css`${ unsafeCSS( styles ) }`;

	/**
	 * The "color" property for the NewTag component.
	 *
	 * @type {String}
	 * @default "primary"
	 */
	@property( { type: String } ) accessor color = "primary";

	/**
	 * The "size" property for the NewTag component.
	 *
	 * @type {String}
	 * @default "size"
	 */
	@property( { type: String } ) accessor size;

	/**
	 * The "text" property for the NewTag component.
	 *
	 * @type {String}
	 * @default "label"
	 */
	@property( { type: String } ) accessor label = "New";

	/**
	 * The "text" property for the NewTag component.
	 *
	 * @type {String}
	 * @default "label"
	 */
	@property( { type: String } ) accessor toolTip = wp.i18n.__( 'New feature', 'uncanny-automator' );

	/**
	 * Render the component's HTML template.
	 *
	 * @return {TemplateResult} The HTML template for the component.
	 */
	render() {
		return html`
			<uo-tooltip>
				${this.toolTip}

				<div
					slot="target"
					class="new-tag"
					color="${ ifDefined( this.color ) }"
					size="${ ifDefined( this.size ) }"
				>
					${this.label}
				</div>
			</uo-tooltip>
		`;
	}
}
